// get_job_review
export const GET_JOB_REVIEW = 'get_job_review';
export const GET_JOB_REVIEW_SUCCESSFUL = 'get_job_review_successfull';
export const GET_JOB_REVIEW_FAILED = 'get_job_review_failed';

// create_job_review
export const CREATE_JOB_REVIEW = 'create_job_review';
export const CREATE_JOB_REVIEW_SUCCESSFUL = 'create_job_review_successfull';
export const CREATE_JOB_REVIEW_FAILED = 'create_job_review_failed';

// update_job_review
export const UPDATE_JOB_REVIEW = 'update_job_review';
export const UPDATE_JOB_REVIEW_SUCCESSFUL = 'update_job_review_successfull';
export const UPDATE_JOB_REVIEW_FAILED = 'update_job_review_failed';

// delete_job_review
export const DELETE_JOB_REVIEW = 'delete_job_review';
export const DELETE_JOB_REVIEW_SUCCESSFUL = 'delete_job_review_successfull';
export const DELETE_JOB_REVIEW_FAILED = 'delete_job_review_failed';
